import React from 'react';
import PropTypes from 'prop-types';

const FiletypePdfPath = ({ fill = '#B32323' }) => {
  return (
    <path
      fill={fill}
      d="M20.057 4.654l5.259 5.027c.382.365.684 1.082.684 1.609v15.084c0 .898-.763 1.626-1.701 1.626H7.701C6.762 28 6 27.272 6 26.374V5.626C6 4.728 6.763 4 7.701 4h10.717c.539 0 1.261.293 1.639.654zm-9.104 17.54c.157.09.33.135.515.135.245 0 .508-.078.774-.233.89-.518 1.789-1.835 2.22-3.624a36.98 36.98 0 0 1 3.079-1.428c1.97.95 3.97 1.309 4.972.788.41-.213.638-.566.638-.994 0-.595-.238-1.06-.687-1.346-.867-.552-2.473-.367-4.884.567a12.27 12.27 0 0 1-1.38-.844 21.895 21.895 0 0 1-1.492-1.148c-.048-2.096-.245-3.671-1.062-4.29-.375-.283-.84-.35-1.378-.198-.757.214-.951.717-1 .998-.181 1.067 1.035 2.568 2.547 3.903.008.566.008 1.153.008 1.736 0 .594-.057 1.149-.155 1.659-2.26 1.228-3.38 2.276-3.417 3.187-.018.463.23.865.702 1.133zm3.77-5.978l-.001-.98c.32.25.642.49.959.715.273.192.554.374.839.544a39.56 39.56 0 0 0-1.862.866c.043-.368.066-.75.066-1.145zm-2.21-5.771a1.06 1.06 0 0 1 .285-.045.47.47 0 0 1 .305.096c.428.323.602 1.383.673 2.723-1.124-1.105-1.698-2.033-1.62-2.49.01-.058.033-.193.357-.284zm9.586 6.587c-.522.27-1.822.156-3.35-.44 2.17-.73 2.963-.512 3.232-.34.115.073.269.214.269.586 0 .046 0 .116-.151.194zM11.15 21.098c.005-.144.158-.781 2.175-1.991-.423 1.143-1.04 1.922-1.536 2.21-.168.099-.32.136-.391.096-.255-.145-.25-.273-.248-.315z"
    />
  );
};

FiletypePdfPath.propTypes = {
  fill: PropTypes.string,
};

export default FiletypePdfPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/filetype/filetype-pdf.jsx